
/**
 * Gets whether an element is scrolled outside of view by any of its parent scrolling containers.
 * \@docs-private
 * @param {?} element Dimensions of the element (from getBoundingClientRect)
 * @param {?} scrollContainers Dimensions of element's scrolling containers (from getBoundingClientRect)
 * @return {?} Whether the element is scrolled out of view
 */
export function isElementScrolledOutsideView(element: ClientRect, scrollContainers: ClientRect[]) {
  return scrollContainers.some(containerBounds => {
    const /** @type {?} */ outsideAbove = element.bottom < containerBounds.top;
    const /** @type {?} */ outsideBelow = element.top > containerBounds.bottom;
    const /** @type {?} */ outsideLeft = element.right < containerBounds.left;
    const /** @type {?} */ outsideRight = element.left > containerBounds.right;

    return outsideAbove || outsideBelow || outsideLeft || outsideRight;
  });
}
/**
 * Gets whether an element is clipped by any of its scrolling containers.
 * \@docs-private
 * @param {?} element Dimensions of the element (from getBoundingClientRect)
 * @param {?} scrollContainers Dimensions of element's scrolling containers (from getBoundingClientRect)
 * @return {?} Whether the element is clipped
 */
export function isElementClippedByScrolling(element: ClientRect, scrollContainers: ClientRect[]) {
  return scrollContainers.some(scrollContainerRect => {
    const /** @type {?} */ clippedAbove = element.top < scrollContainerRect.top;
    const /** @type {?} */ clippedBelow = element.bottom > scrollContainerRect.bottom;
    const /** @type {?} */ clippedLeft = element.left < scrollContainerRect.left;
    const /** @type {?} */ clippedRight = element.right > scrollContainerRect.right;

    return clippedAbove || clippedBelow || clippedLeft || clippedRight;
  });
}



// WEBPACK FOOTER //
// ../../../src/cdk/overlay/position/scroll-clip.ts